import { useEffect } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { useI18n } from 'locales'
import HexCheckIcon from 'components/confirmation/hex-check.svg'
import CollapsibleSpotTimes from 'components/enter_details/collapsible_spot_times'
import {
  Container,
  PollConfirmationFooter,
  CookieSettingsButton
} from 'components/confirmation/layout'
import { groupedSelectedSpotsSelector } from 'selectors'
import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'

import { Header, Title, Description } from './styles'

export const MeetingPollConfirmation = () => {
  const { eventType } = useConfirmationPageData()
  const history = useHistory()
  const { params } = useRouteMatch()
  const { i18n } = useI18n()
  const groupedSelectedSpots = useSelector(groupedSelectedSpotsSelector)
  const selectedSpotsCount = groupedSelectedSpots
    ? Object.values(groupedSelectedSpots).flat().length
    : 0

  useEffect(() => {
    if (eventType && (eventType.booking_method !== 'poll' || selectedSpotsCount === 0)) {
      const linkUid = params?.linkUid
      const eventTypeName = params?.eventTypeName

      if (linkUid && eventTypeName) {
        const bookingPath = `/d/${linkUid}/${eventTypeName}`
        history.push(bookingPath)
      }
    }
  }, [eventType, history, params?.linkUid, params?.eventTypeName, selectedSpotsCount])

  if (!eventType || eventType.booking_method !== 'poll' || selectedSpotsCount === 0) {
    return null
  }

  return (
    <Container>
      <Header>
        <img src={HexCheckIcon} alt="" />
        <Title>
          {i18n.t('booking.templates.poll.confirmation.title')}
        </Title>
        <Description>
          {i18n.t('booking.templates.poll.confirmation.description')}
        </Description>
      </Header>
      <CollapsibleSpotTimes isCentered />
      <PollConfirmationFooter />
      <CookieSettingsButton />
    </Container>
  )
}
